module.exports = __webpack_public_path__ + "img/smb-key-keeper-black.256.334bff0c.png";